'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

// Selectors


// Utils


// Components


// Styles


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reselect = require('reselect');

var _recompose = require('recompose');

var _lodash = require('lodash');

var _permissionsService = require('../../utils/permissions/permissionsService');

var _boardSelector = require('../board/boardSelector');

var _permissionUtil = require('../../../common/permissions/permissionUtil');

var _resourceUtil = require('../../utils/services/http/resources/resourceUtil');

var _Board = require('../board/Board');

var _Board2 = _interopRequireDefault(_Board);

var _BoardContainer = require('../board/BoardContainer');

var _BoardContainer2 = _interopRequireDefault(_BoardContainer);

var _AliasLoading = require('./AliasLoading');

var _AliasLoading2 = _interopRequireDefault(_AliasLoading);

var _elementLineEdgeDropTarget = require('../line/elementLineEdgeDropTarget');

var _elementLineEdgeDropTarget2 = _interopRequireDefault(_elementLineEdgeDropTarget);

require('./Alias.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var aliasSelector = (0, _reselect.createSelector)(function (state, ownProps) {
    return state.get('elements');
}, function (state, props) {
    return props.element.getIn(['content', 'linkTo']);
}, _permissionsService.aliasUserPermissionsSelector, _boardSelector.boardResourcesSelector, function (elements, linkedElementId, boardPermissions, boardResourcesState) {
    var linkedBoard = elements.get(linkedElementId);
    var linkedBoardResourceState = boardResourcesState.get(linkedElementId);

    var isLocked = linkedBoard && (0, _resourceUtil.isFetched)(linkedBoardResourceState) && !(0, _permissionUtil.canRead)(boardPermissions);

    return { isLocked: isLocked, linkedElementId: linkedElementId, linkedBoard: linkedBoard };
});

var Alias = function Alias(props) {
    var linkedBoard = props.linkedBoard,
        isPresentational = props.isPresentational,
        element = props.element;


    if (!linkedBoard || !linkedBoard.get('content') || linkedBoard.get('error')) {
        return _react2.default.createElement(_AliasLoading2.default, props);
    }

    var isLinkAlias = element.getIn(['content', 'linkAlias']);

    return isPresentational ? _react2.default.createElement(_Board2.default, _extends({}, props, { aliasId: element.get('id'), isAlias: true, isLinkAlias: isLinkAlias, element: linkedBoard })) : _react2.default.createElement(_BoardContainer2.default, _extends({}, props, { aliasId: element.get('id'), isAlias: true, isLinkAlias: isLinkAlias,
        element: linkedBoard }));
};

Alias.propTypes = {
    linkedElementId: _propTypes2.default.string,
    isPresentational: _propTypes2.default.bool,
    linkedBoard: _propTypes2.default.object,
    element: _propTypes2.default.object
};

var enhance = (0, _recompose.compose)((0, _reactRedux.connect)(aliasSelector), (0, _recompose.branch)(function (props) {
    return props.isPresentational;
}, _lodash.identity, _elementLineEdgeDropTarget2.default));

exports.default = enhance(Alias);


//////////////////
// WEBPACK FOOTER
// ./src/client/element/alias/Alias.js
// module id = 1949
// module chunks = 0